export const MAX_X_UPVOTE_ICE_BOOST = 10;
export const MAX_BOOST = 9;

export const ICE_READ_TIMEOUT_MS = 30_000;

// Classic lock rules (a network without a Locker): a lock lasts from a day up to 10 years, the
// ICE estimate reaches the full boost at 3 years and the slider spans 5 years.
export const MAX_BOOST_PERIOD = 3 * 365 * 24 * 60 * 60 * 1000;
export const MIN_BOOST_PERIOD = 24 * 60 * 60 * 1000;
export const MAX_LOCK_PERIOD = 10 * 365 * 24 * 60 * 60 * 1000;
export const RECOMMENDED_LOCK_PERIOD = 5 * 365 * 24 * 60 * 60 * 1000;

// ICE Locker time rules: unlock times fall on Monday 00:00 UTC, a lock must last more than a
// day, and the ICE boost decays linearly over the last 156 weeks of a lock (also the longest
// lock the Locker accepts).
export const LOCK_WEEK_SEC = 604_800;
export const LOCK_MONDAY_OFFSET_SEC = 345_600;
export const MIN_LOCK_DURATION_SEC = 86_400;
export const ICE_DECAY_HORIZON_SEC = 156 * LOCK_WEEK_SEC;
